module.exports = __webpack_public_path__ + "img/career.143bcb55.svg";